import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TagBox } from '../../molecules/TagBox'
import Tooltip from '../../atoms/Tooltip'
import BaseIconButton from '../../atoms/BaseIconButton'
import VisibilityIcon from '../../atoms/icons/Visibility'
import VisibilityOffIcon from '../../atoms/icons/VisibilityOff'

const emailVerificationText = {
  true: { label: 'Si', tagType: 'success' },
  false: { label: 'No', tagType: 'neutral' }
}

const UserEmailVerification = ({ user }) => {
  const isVerified = !!user.confirmed_at
  const status = emailVerificationText[isVerified]
  const [showToken, setShowToken] = useState(false)

  const toggleVisibility = () => {
    setShowToken(!showToken)
  }

  return (
    <div className="flex flex-col items-center gap-1">
      <TagBox className="text-xs" label={status.label} tagType={status.tagType} />
      {user.is_current_user_admin && user.confirmation_token && (
        <div className="flex items-center gap-1 justify-center w-full mt-1">
          <span className="font-mono text-sm tracking-widest text-gray-700">
            {showToken ? user.confirmation_token : '******'}
          </span>
          <Tooltip title={showToken ? 'Ocultar código' : 'Ver código'} type="light">
            <BaseIconButton
              color="primary"
              ariaLabel={showToken ? 'Ocultar Código' : 'Ver Código'}
              onClick={toggleVisibility}
              size="small"
              className="p-1"
            >
              {showToken ? (
                <VisibilityOffIcon className="text-xl text-gray-700 hover:text-primary cursor-pointer" />
              ) : (
                <VisibilityIcon className="text-xl text-gray-700 hover:text-primary cursor-pointer" />
              )}
            </BaseIconButton>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

UserEmailVerification.propTypes = {
  user: PropTypes.object
}

export default UserEmailVerification
